import { Play } from "phosphor-react"
import React from "react"

interface Props {
  muxPlaybackId: string | null | undefined
  className?: string
}

export const MessageAttachmentVideo: React.FC<Props> = ({ muxPlaybackId, className }) => {
  if (!muxPlaybackId) return null

  const url = new URL(`https://image.mux.com/${muxPlaybackId}/thumbnail.png`)

  return (
    <div className="relative flex w-full">
      <img src={url.toString()} className={className} />
      <div className="absolute inset-0 flex items-center justify-center">
        <Play size={40} className="text-base-white" weight="fill" />
      </div>
    </div>
  )
}
